module.exports = __webpack_public_path__ + "static/img/1.f2a1adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/7/1.png
// module id = M3eY
// module chunks = 1